import { render, staticRenderFns } from "./tablePages.vue?vue&type=template&id=35f3f3d0&scoped=true&"
import script from "./tablePages.vue?vue&type=script&lang=js&"
export * from "./tablePages.vue?vue&type=script&lang=js&"
import style0 from "./tablePages.vue?vue&type=style&index=0&id=35f3f3d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f3f3d0",
  null
  
)

component.options.__file = "tablePages.vue"
export default component.exports